import React from "react";
import { LabelledText, WhitePanelWithHeader } from "ui";
import PreferredProgrammeBadge from "../PreferredProgrammes/PreferredProgrammeBadge";

const ManagedTrinityUser = ({ name, email, phone, venueId, isInProgramme }) => {
  return (
    <WhitePanelWithHeader title="Managed By" icon="far fa-user">
      <LabelledText label="Agent Name" text={name} />
      <LabelledText label="Agent Email" text={email} />
      <LabelledText label="Agent Phone" text={phone ? phone : "Not Provided"} />
      {venueId && isInProgramme ? (
        <PreferredProgrammeBadge
          isInProgramme={isInProgramme}
          venueId={venueId}
          displayAgency={true}
        />
      ) : null}
    </WhitePanelWithHeader>
  );
};

export default ManagedTrinityUser;
